import {
  FacebookImportRequestsQuery,
  FacebookImportRequestsQueryVariables
} from './__generated__/FacebookImportRequestsQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { FACEBOOK_IMPORT_REQUESTS_QUERY } from './facebookImportRequests.query';

export const useFacebookImportRequestsQuery = (variables: FacebookImportRequestsQueryVariables) => {
  return useLazyQuery<FacebookImportRequestsQuery>(FACEBOOK_IMPORT_REQUESTS_QUERY, {
    variables,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
